
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#4E6492","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M19.703 0H.317A.317.317 0 000 .317v15.157c0 .175.142.317.317.317h19.386a.317.317 0 00.317-.317V.317A.317.317 0 0019.703 0zm-1.586 13.262l-4.362-4.517a.13.13 0 00-.18-.008l-3.025 2.664-3.868-4.762a.13.13 0 00-.204.004L1.903 12.78V1.903h16.214v11.36z"}}),_c('path',{attrs:{"d":"M12.556 6.113a1.556 1.556 0 100-3.113 1.556 1.556 0 000 3.113z"}})])])
          )
        }
      }
    